export const getSeconds = (fDate: number, sDate: number) => {
  const hours = Math.abs(fDate - sDate) / 1000;
  return hours;
};

export const getHours = (fDate: number, sDate: number) => {
  const hours = Math.abs(fDate - sDate) / 36e5;
  return hours;
};
